import React from "react";

export default function SleepType({ sleepType, selected, onClick }) {
  const selectedClasses = selected
    ? "bg-slate-800 hover:bg-slate-700 text-white shadow-md"
    : "bg-stone-100 hover:bg-stone-50 text-gray-900";

  // Aria label text should dynamically describe the button's function
  const ariaLabel = `${selected ? "Sélectionné: " : ""}${sleepType === "wakeUp" ? "Je veux me lever à" : "Je veux me coucher à"
    }`;

  return (
    <button
      onClick={onClick}
      className={`cursor-pointer ${selectedClasses} active:bg-slate-600 active:text-white focus:ring focus:ring-slate-300 w-1/2 rounded-lg px-2 sm:px-4 py-4 sm:py-6`}
      aria-label={ariaLabel}
      aria-pressed={selected} // Correctly communicates the toggle state of the button
      role="button" // Explicitly specifies the role for better accessibility
    >
      {sleepType === "wakeUp" ? (
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" className="fill-current w-full">
            <path d="M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z" stroke="currentColor" stroke-width="1.5" />
            <path d="M12 2V3.5M12 20.5V22M19.0708 19.0713L18.0101 18.0106M5.98926 5.98926L4.9286 4.9286M22 12H20.5M3.5 12H2M19.0713 4.92871L18.0106 5.98937M5.98975 18.0107L4.92909 19.0714" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <div className="text-sm sm:text-base font-semibold mt-2">Je me réveille à</div>

        </div>
      ) : (
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" className="fill-current w-full" >
            <path d="M21.5 14.0784C20.3003 14.7189 18.9301 15.0821 17.4751 15.0821C12.7491 15.0821 8.91792 11.2509 8.91792 6.52485C8.91792 5.06986 9.28105 3.69968 9.92163 2.5C5.66765 3.49698 2.5 7.31513 2.5 11.8731C2.5 17.1899 6.8101 21.5 12.1269 21.5C16.6849 21.5 20.503 18.3324 21.5 14.0784Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <div className="text-sm sm:text-base font-semibold mt-2">Je m'endors à</div>
        </div>
      )}
    </button>
  );
}
